import { authStore } from './auth-store'

const REQUEST_KEY = 'auth_session_request'
const SHARE_KEY = 'auth_session_share'
const INHERIT_TIMEOUT_MS = 300

function pulse(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
    window.localStorage.removeItem(key)
  } catch {
    /* intentionally ignored */
  }
}

export function registerTabSession(): () => void {
  if (typeof window === 'undefined') return () => {}

  const onStorage = (event: StorageEvent) => {
    if (
      event.key === REQUEST_KEY &&
      event.newValue &&
      authStore.hasSessionMarker()
    ) {
      pulse(SHARE_KEY, '1')
    }
  }

  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}

export function requestSessionInheritance(
  timeoutMs = INHERIT_TIMEOUT_MS,
): Promise<boolean> {
  if (typeof window === 'undefined') return Promise.resolve(false)

  return new Promise<boolean>(resolve => {
    let settled = false

    const onStorage = (event: StorageEvent) => {
      if (event.key === SHARE_KEY && event.newValue === '1') finish(true)
    }

    const finish = (inherited: boolean) => {
      if (settled) return
      settled = true
      window.removeEventListener('storage', onStorage)
      window.clearTimeout(timer)
      if (inherited) authStore.activateBrowserSession()
      resolve(inherited)
    }

    window.addEventListener('storage', onStorage)
    const timer = window.setTimeout(() => finish(false), timeoutMs)
    pulse(REQUEST_KEY, String(Date.now()))
  })
}

export const __testing = {
  REQUEST_KEY,
  SHARE_KEY,
  INHERIT_TIMEOUT_MS,
}
